export default {
    progress: 'Login in progress, please wait...',
    pageTitle: 'SSO LOGIN',
    missingCode: 'Authorisation code missing',
    errors: {
        invalid_request: 'There is an error in the protocol, for example, a required parameter is missing.',
        unauthorized_client: 'The client application is not installed in the Azure AD or cannot be added to the tenant and therefore must not request an authorization code.',
        access_denied: 'The user has denied consent for the client application.',
        unsupported_response_type: 'The authorization server does not support the authorization grant type, please correct the request.',
        server_error: 'An unexpected error has occurred in the server. Please retry the operation.',
        temporarily_unavailable: 'The server cannot process the request at the moment. Please retry the operation.',
        invalid_resource: 'The requested resource is not valid. Install the application in Azure AD or correct the configuration.',
        login_required: 'No user could be found.',
        interaction_required: 'Please complete the additional step required for authentication.'
    }
}
